import React, { ReactElement } from 'react';

import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Main from './components/mainScreen';
import theme from './theme';
import store from './store';

function App(): ReactElement {
  return (
    <div className="App">
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Main />
        </MuiThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
